import $ from 'jquery';
import empty from './utils/empty';
import Sections from './sections';
import ContentsList from './contents-list';

class Chapters {
    constructor($selector, $contentsList) {
        this.$chapters = $selector;
        this.$firstChapterId = this.$chapters.first().attr('id');
        this.Sections = new Sections(this.getCurrentChapter(), $contentsList);
        this.$contentsList = $contentsList;

        $(window).on('hashchange', $.proxy(this.urlChanged, this));
        $(window).on('load', $.proxy(this.init(), this));
    }

    getCurrentChapter() {
        return this.$chapters.filter(function () {
            return ($(this).hasClass('is-current'));
        });
    }

    urlChanged(e, data) {
        if (data !== undefined) {
            const url = data.url;
            const urlSplit = url.split('#');

            let id = urlSplit[0];
            let hash = '';

            if (urlSplit.length > 1) {
                hash = urlSplit[1];
            }

            const $currentChapter = this.getCurrentChapter();

            id = id.replace('/^\//', '').split('/');

            if (id.length > 1) {
                id = id.reverse()[0];
            } else {
                id = id[0];
            }

            if (id === '') {
                id = $currentChapter.prop('id');
            }

            const $chapter = this.$chapters.filter(function () {
                return (this.id === id);
            });

            if (!empty($chapter) && $currentChapter.prop('id') !== id) {
                //toggle the cover and other components
                if (this.$firstChapterId === id) {
                    $('body').addClass('is-landing-page');
                } else {
                    $('body').removeClass('is-landing-page');
                }

                //toggle the chapter
                this.$chapters.removeClass('is-current').addClass('is-hidden');
                $chapter.removeClass('is-hidden').addClass('is-current');

                this.Sections.setContent($chapter);
            }
        }
    }

    init() {
        this.goToChapter();
    }

    goToChapter() {
        const href = window.location.href;
        const path = window.location.pathname;

        if (href.toString().indexOf('#') < 0) {
            const pathParts = path.split('/');
            const chapterPath = pathParts[pathParts.length - 1];

            const $elem = $('.js-contents-list__link').filter(() => {
                return $(this).attr('href') === chapterPath;
            });

            this.$contentsList.goTo($elem, chapterPath, false);
        }
    }

}

export default Chapters;

